import React, { Component } from 'react';
import {
    LineChart, Line, ResponsiveContainer } from 'recharts';
import classNames from 'classnames';
import { API_URL } from '../../config';

class Chart extends Component {

    state = {
        isLoading: true,
        data:[]
    };


    async fetchChartData() {
        const res = await this.props.fetch(API_URL(`/report/IndexLast12/companies/${this.props.companyId}/branches/${this.props.branchId}`)); 
        
        if (!res.ok) {
            //handle 404
        }
        return await res.json();
    }

    async componentDidMount() {
        this.setState({
            isLoading: true
        });

        const data = await this.fetchChartData();        

        this.setState({
            isLoading: false,
            data
        });
    }

    render() {

        return (
            <div className={classNames({
                'statstics-list__item-chart': true,
                'statstics-list__item-chart--is-loading': this.state.isLoading
            })}>
                <div className="statstics-list__chart">
                    
                    <ResponsiveContainer width="100%" height={75}>
                        <LineChart data={this.state.data.indexR12Periods}>
                            <defs>
                                <linearGradient id="colorUv" x1="0%" y1="0%" x2="100%" y2="0%">
                                <stop offset="0%" stopColor="#3ebcb3" />
                                <stop offset="100%" stopColor="#64d146" />
                                </linearGradient>
                            </defs>
                            <Line type="linear" dot={false} dataKey="indexAll" stroke="#dddddd" strokeWidth={3} />
                            <Line type="linear" dot={false} dataKey="indexCompany" stroke="url(#colorUv)" strokeWidth={3} />
                        </LineChart>
                    </ResponsiveContainer>
                </div>
                <div className="statstics-list__chart-col-container">
                    <div className="statstics-list__chart-col">
                        <span className="statstics-list__chart-val">{this.state.data.indexCompanyTotal && this.state.data.indexCompanyTotal.toLocaleString('sv')}</span>
                        <span title={this.props.companyName} className="statstics-list__chart-legend statstics-list__chart-legend--self">{this.props.companyName}</span>
                    </div>
                    <div className="statstics-list__chart-col">
                        <span className="statstics-list__chart-val">{this.state.data.indexAllTotal && this.state.data.indexAllTotal.toLocaleString('sv')}</span>
                        <span title="Branschindex" className="statstics-list__chart-legend">Branschindex</span>
                    </div>
                </div>
            </div>
        );
    }
};

export default Chart;